export const CREATE_DESIGN  = 'CREATE_DESIGN';
export const GET_DESIGN  = 'GET_DESIGN';
export const DESIGN_REQUEST  = 'DESIGN_REQUEST';
export const DELETE_DESIGN  = 'DELETE_DESIGN';
export const UPDATE_DESIGN  = 'UPDATE_DESIGN';
export const DESIGN_REQUEST_FAILURE  = 'DESIGN_REQUEST_FAILURE';